import {CommonService} from '../../../services/common.service';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  templateUrl: './sale-point-plirotis-dialog.component.html'
})
export class SalePointPlirotisDialogComponent implements OnInit {
  edit: boolean;
  title: string;
  plirotisCode: any;
  plirotisName: string;
  vatNumber: string;

  constructor(private commonService: CommonService,
              private matDialogRef: MatDialogRef<SalePointPlirotisDialogComponent>) {
    this.title = 'Προσθήκη νέας γραμμής';
  }

  public async ngOnInit(): Promise<any> {
  }

  close(item?) {
    this.matDialogRef.close(item);
  }

  submitSpPlirotis() {
    const model = {
      plirotis_code: this.plirotisCode,
      plirotis_name: this.plirotisName,
      vat_number: this.vatNumber
    };
    this.close(model);
  }

  formInvalid(): boolean {
    return !this.plirotisCode || !this.plirotisName || !this.vatNumber;
  }
}
